export default "https://static.wetvinfo.com/tv/linux/static/media/playing.png";